import React from 'react';

const ImportExcelIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="490"
    height="490"
    viewBox="0 0 24 24">
    <path fill="#293840" fillRule="evenodd" d="M14.882 0c.18 0 .356.06.498.169l.081.071 4.64 4.64c.127.127.209.293.232.471l.007.108v6.649h3.635v1.639H20.34v9.032c0 .663-.537 1.2-1.2 1.2H1.2c-.663 0-1.2-.537-1.2-1.2L.005 1.2c0-.663.538-1.2 1.2-1.2h13.677zm-.82 1.639H1.644v20.722h17.056v-8.614h-2.77l1.386 1.385c.293.293.317.754.073 1.075l-.073.084c-.156.156-.364.24-.58.24-.18 0-.354-.059-.497-.168l-.082-.072-2.784-2.784c-.293-.293-.318-.754-.073-1.075l.073-.084 2.784-2.783c.32-.32.839-.32 1.159 0 .293.293.317.754.073 1.075l-.073.084-1.386 1.384h2.77v-5.83h-3.82c-.417 0-.762-.312-.813-.716l-.006-.103v-3.82zm-.536 15.645v1.639H4v-1.64h9.526zM10.67 13.5v1.64H4V13.5h6.67zm0-3.784v1.633H4V9.716h6.67zm.996-3.777V7.566H4v-.813-.814h7.666zM15.7 2.797v1.842h1.842L15.7 2.797z"/>
  </svg>
);

export default ImportExcelIcon;
